import api from './api'

const addStripePaymentMethod = data =>
  api.billing
    .post('users/me/payment-methods/stripe', data)
    .then(res => res.data)

const removeStripePaymentMethod = paymentMethodId =>
  api.billing
    .delete(`users/me/payment-methods/stripe/${paymentMethodId}`)
    .then(res => res.data)

const getPaymentMethods = () =>
  api.billing.get('users/me/payment-methods').then(res => res.data)

export default {
  getPaymentMethods,
  addStripePaymentMethod,
  removeStripePaymentMethod
}
